import { forwardRef } from 'react';

export const HouseIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.3056 7.976C27.5056 7.82964 27.7771 7.82855 27.9783 7.97331L37.371 14.7315C37.5206 14.8391 37.6092 15.0121 37.6092 15.1964V34.1727C37.6092 34.4891 37.3528 34.7455 37.0365 34.7455H3.16922C2.85292 34.7455 2.5965 34.4891 2.5965 34.1727V17.8691C2.5965 17.5528 2.85292 17.2964 3.16922 17.2964H17.6783V15.3109C17.6783 15.1283 17.7654 14.9566 17.9128 14.8487L27.3056 7.976ZM27.6466 9.14581L18.8238 15.6015V17.8691C18.8238 18.1854 18.5674 18.4418 18.251 18.4418H3.74195V33.6H36.4638V15.4899L27.6466 9.14581Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.306 5.07374C27.5058 4.92797 27.7765 4.92682 27.9774 5.07091L39.852 13.5855C40.109 13.7698 40.168 14.1276 39.9837 14.3846C39.7994 14.6417 39.4416 14.7007 39.1845 14.5163L27.6467 6.24324L16.1068 14.6662C15.8513 14.8527 15.493 14.7968 15.3065 14.5413C15.1201 14.2858 15.176 13.9275 15.4315 13.741L27.306 5.07374Z"
        />
        <path d="M3.16922 17.9836L5.23104 11.76H18.9383L15.6165 14.28L18.0601 15.2346V17.9073L3.16922 17.9836Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.68738 11.5799C4.76502 11.3455 4.98414 11.1873 5.23105 11.1873H18.9383C19.1843 11.1873 19.4027 11.3443 19.4812 11.5774C19.5596 11.8105 19.4804 12.0676 19.2845 12.2163L16.777 14.1184L18.2685 14.7011C18.4882 14.7869 18.6329 14.9986 18.6329 15.2345V17.9073C18.6329 18.2224 18.3782 18.4784 18.0631 18.48L3.17217 18.5563C2.98774 18.5573 2.81414 18.4694 2.70578 18.3201C2.59742 18.1709 2.56756 17.9786 2.62556 17.8035L4.68738 11.5799ZM5.64465 12.3327L3.96366 17.4068L17.4874 17.3375V15.6257L15.4081 14.8135C15.2151 14.738 15.0778 14.5642 15.0492 14.3589C15.0207 14.1537 15.1052 13.949 15.2704 13.8237L17.2357 12.3327H5.64465Z"
        />
        <path d="M16.5709 22.9092H5.91818V34.1728H16.5709V22.9092Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.34546 22.9092C5.34546 22.5928 5.60188 22.3364 5.91819 22.3364H16.5709C16.8872 22.3364 17.1436 22.5928 17.1436 22.9092V34.1728C17.1436 34.4891 16.8872 34.7455 16.5709 34.7455H5.91819C5.60188 34.7455 5.34546 34.4891 5.34546 34.1728V22.9092ZM6.49091 23.4819V33.6001H15.9982V23.4819H6.49091Z"
        />
        <path d="M25.5817 18.2891H22.2217V22.4891H25.5817V18.2891Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.649 18.289C21.649 17.9727 21.9054 17.7163 22.2217 17.7163H25.5817C25.898 17.7163 26.1544 17.9727 26.1544 18.289V22.489C26.1544 22.8053 25.898 23.0618 25.5817 23.0618H22.2217C21.9054 23.0618 21.649 22.8053 21.649 22.489V18.289ZM22.7944 18.8618V21.9163H25.009V18.8618H22.7944Z"
        />
        <path d="M32.8363 18.2891H29.4763V22.4891H32.8363V18.2891Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.9035 18.289C28.9035 17.9727 29.16 17.7163 29.4763 17.7163H32.8363C33.1526 17.7163 33.409 17.9727 33.409 18.289V22.489C33.409 22.8053 33.1526 23.0618 32.8363 23.0618H29.4763C29.16 23.0618 28.9035 22.8053 28.9035 22.489V18.289ZM30.049 18.8618V21.9163H32.2635V18.8618H30.049Z"
        />
        <path d="M25.5817 25.5054H22.2217V29.7054H25.5817V25.5054Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.649 25.5053C21.649 25.189 21.9054 24.9326 22.2217 24.9326H25.5817C25.898 24.9326 26.1544 25.189 26.1544 25.5053V29.7053C26.1544 30.0216 25.898 30.2781 25.5817 30.2781H22.2217C21.9054 30.2781 21.649 30.0216 21.649 29.7053V25.5053ZM22.7944 26.0781V29.1326H25.009V26.0781H22.7944Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.9035 25.5053C28.9035 25.189 29.16 24.9326 29.4763 24.9326H32.8363C33.1526 24.9326 33.409 25.189 33.409 25.5053V34.1726C33.409 34.4889 33.1526 34.7453 32.8363 34.7453H29.4763C29.16 34.7453 28.9035 34.4889 28.9035 34.1726V25.5053ZM30.049 26.0781V33.5999H32.2635V26.0781H30.049Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.52728 37.4182C1.52728 37.1019 1.7837 36.8455 2.10001 36.8455H40.2818C40.5981 36.8455 40.8546 37.1019 40.8546 37.4182C40.8546 37.7345 40.5981 37.9909 40.2818 37.9909H2.10001C1.7837 37.9909 1.52728 37.7345 1.52728 37.4182Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.52936 28.5219C6.52936 28.2056 6.78578 27.9492 7.10209 27.9492H15.4639C15.7802 27.9492 16.0366 28.2056 16.0366 28.5219C16.0366 28.8383 15.7802 29.0947 15.4639 29.0947H7.10209C6.78578 29.0947 6.52936 28.8383 6.52936 28.5219Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.52936 25.6963C6.52936 25.38 6.78578 25.1235 7.10209 25.1235H15.4639C15.7802 25.1235 16.0366 25.38 16.0366 25.6963C16.0366 26.0126 15.7802 26.269 15.4639 26.269H7.10209C6.78578 26.269 6.52936 26.0126 6.52936 25.6963Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.52936 31.3091C6.52936 30.9927 6.78578 30.7363 7.10209 30.7363H15.4639C15.7802 30.7363 16.0366 30.9927 16.0366 31.3091C16.0366 31.6254 15.7802 31.8818 15.4639 31.8818H7.10209C6.78578 31.8818 6.52936 31.6254 6.52936 31.3091Z"
          fill="white"
        />
      </svg>
    );
  },
);
